import { render, staticRenderFns } from "./inputs.vue?vue&type=template&id=01bde9aa&scoped=true"
import script from "./inputs.vue?vue&type=script&lang=js"
export * from "./inputs.vue?vue&type=script&lang=js"
import style0 from "./inputs.vue?vue&type=style&index=0&id=01bde9aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bde9aa",
  null
  
)

export default component.exports